import { T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS } from './TYPES'

const HU_TERMS_AND_CONDITIONS_PAGE_CONSTANTS: T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS =
  {
    PAGE_KICKER: 'GRIFFYREADS',
    PAGE_TITLE: 'Általános Szerződési Feltételek',
    PAGE_CONTENT: [
      {
        TITLE: 'Bevezetés',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Üdvözöljük a GriffyReads platformon. Ezen Általános Szerződési Feltételek (a továbbiakban: Feltételek) irányadók a gyermekek és felnőttek számára készült kvízalapú alkalmazásunk, a GriffyReads (a továbbiakban: az Alkalmazás) használatára. Az Alkalmazás elérésével vagy használatával a felnőtt felhasználók elfogadják a jelen Feltételeket. ',
              'Az alkalmazás célja az offline olvasás népszerűsítése a gyermekek körében. Ennek érdekében az Alkalmazás olvasmányok megértését tesztelő, feleletválasztós kvízek adatbázisát kínálja. Egyúttal egy közösségi platform, mivel kvízeket bármely felnőtt felhasználó (szülők, tanárok stb.) feltölthet. ',
              'Az Alkalmazásban „kalandoroknak” nevezett gyermekek akként használják az Alkalmazást, hogy a platformon kiválasztanak egy adott könyvet, elolvassák azt (offline), majd kitöltik a könyvhöz tartozó, az olvasott szöveg megértését tesztelő, öt feleletválasztós kérdésből álló kvízt. A helyes válaszokért pontokat kapnak, amely lehetővé teszi kabalakarakterük – egy Griffy nevű griffmadár-fióka – fejlődését. A kalandorok vagy egyénileg játszanak, vagy részt vehetnek a felnőtt felhasználók által szervezett eseményeken és versenyeken más kalandorokkal együtt. A platform csupán meghatározott azonosítási információkat tartalmaz egy adott könyvről (pl. szerző, kiadó, borítókép), magát a könyvet nem.'
            ]
          }
        ]
      },
      {
        TITLE: 'Felhasználók és regisztráció',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Az alkalmazás felnőttek és gyermekek számára készült. „Felnőtt”: a nagykorúságot, azaz a 18. életévét betöltött személy. 13 év alatti gyermekek csak felnőtt felügyelete mellett használhatják az Alkalmazást. ',
              'A felnőtt felhasználók versenyeket hozhatnak létre a gyermekek számára. ',
              'Az Alkalmazás használatához a felnőtt felhasználóknak regisztrálniuk kell, megadva bizonyos adatokat. A bejelentkezéshez e-mail címet és jelszót használnak. Csak felnőttek regisztrálhatnak fiókot. Miután regisztráltak, létrehozhatnak egy gyermek (kalandor) fiókot. Ezt követően a kalandorok önállóan jelentkezhetnek be a fiókjukba. ',
              'A regisztrációt követően 14 napos próbaidőszak áll rendelkezésre. A felnőttek felhasználóknak előfizetési csomagot kell választaniuk, hogy a próbaidőszakon túl teljes hozzáférést kapjanak az alkalmazáshoz. ',
              'A felnőtt felhasználók felelősek a regisztráció során megadott információk pontosságáért.'
            ]
          }
        ]
      },
      {
        TITLE: 'Az Alkalmazás használata',
        CONTENT: [
          {
            TYPE: 'LIST',
            CONTENT: [
              'Részvétel a kvízekben: A gyerekek (kalandorok) elolvassák (vagy kisebb gyermekek esetében felolvassák nekik) a kiválasztott könyvet, és az olvasott szöveg megértését tesztelő kvízeket töltenek ki az Alkalmazásban. Minden helyes válaszért pont jár, amelynek eredményeként a Griffy-jük fejlődik, egyre erősebb, nagyobb lesz. A pontszerzés egyúttal szintlépéshez és karakterfejlődéshez vezet. ',
              'Versenyek, események: A felnőtt felhasználók olvasási versenyeket hozhatnak létre a kalandorok számára. E versenyeket jellemzően a tanárok szervezik a diákjaik számára. Az Alkalmazás adminisztrátorai ún. eseményeket hozhatnak létre, amelyek olyan publikus versenyek, amelyekben jellemzően nagyobb csoportok (pl. korcsoportok) vehetnek részt. ',
              'Minden résztvevő megtekintheti a ranglistán elfoglalt helyét (a verseny vagy esemény szervezőjének lehetősége van a ranglista anonimizálására), és a legjobb eredményt elérők kitűzőket kapnak. ',
              'Virtuális könyvtár, könyvcsere: A gyermekek az Alkalmazásban „virtuális könyvtárat” állíthatnak össze a meglévő könyveikből, és jelezhetik barátaik számára a könyvek megosztására irányuló szándékukat az alkalmazáson belül.  ',
              'Barátok listája: A gyerekek hozzáadhatnak más gyerekeket a barátlistájához, lehetővé téve számukra, hogy megtekintsék egymás könyveit, és megkönnyítsék a könyvcserét és a kapcsolattartást.'
            ]
          }
        ]
      },
      {
        TITLE: 'Tartalom és magatartás',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'A felnőtt felhasználók felelősek az általuk nyújtott tartalomért és az alkalmazás használata során tanúsított magatartásukért. Bármilyen nem megfelelő, sértő vagy káros tartalom vagy viselkedés a fiók felfüggesztését vagy megszüntetését eredményezheti. ',
              'A kvízek vagy kapcsolódó tartalmak („Felhasználói tartalom”) Alkalmazáson keresztül történő feltöltésével, benyújtásával vagy más módon történő elérhetővé tételével a felnőtt felhasználók elfogadják, hogy az ilyen tartalom az Adonis Consultancy kizárólagos szellemi tulajdonává válik. A felnőtt felhasználók ezennel visszavonhatatlanul átruházzák, átruházzák és átadják az Adonis Consultancy-nak a Felhasználói Tartalommal kapcsolatos összes jogot, jogcímet és érdekeltséget, beleértve korlátozás nélkül az összes szerzői jogot és egyéb szellemi tulajdonjogot. ',
              'A felnőtt felhasználók továbbá tudomásul veszik és elfogadják, hogy az Adonis Consultancy korlátlan joggal rendelkezik a Felhasználói tartalom használatára, reprodukálására, módosítására, terjesztésére, megjelenítésére, előadására és egyéb módon történő felhasználására bármilyen kereskedelmi vagy egyéb célra, kompenzáció, hozzárendelés vagy további értesítés nélkül. ',
              'A tartalom benyújtásával a felnőtt felhasználók kijelentik és garantálják, hogy a felhasználók minden szükséges joggal és engedéllyel rendelkeznek a megbízás megadásához, és hogy a tartalom nem sérti a harmadik felek jogait.'
            ]
          }
        ]
      },
      {
        TITLE: 'Adatvédelem',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Az Alkalmazás használatát az Adatvédelmi Tájékoztatónk is szabályozza, amely részletezi, hogy az Adatkezelő hogyan gyűjti, használja és védi személyes adatait.'
            ]
          }
        ]
      },
      {
        TITLE: 'Előfizetés és fizetés',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Az Alkalmazás előfizetéses modell alapján működik, amelyben a felnőtt felhasználók meghatározott összeget fizetnek annak érdekében, hogy gyermekeik számára elérhetővé tegyék a platformot. Többféle előfizetési csomag érhető el. A fizetés PayPal-on keresztül történik. Egy adott előfizetési csomag kiválasztásával a felnőtt felhasználó elfogadja az előfizetési díj és az esetleges adók megfizetését.'
            ]
          }
        ]
      },
      {
        TITLE: 'Az alkalmazás módosításai',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Fenntartjuk a jogot, hogy az Alkalmazást átmenetileg vagy véglegesen, értesítéssel vagy anélkül módosítsuk vagy megszüntessük. Nem vállalunk felelősséget az Alkalmazás bármilyen módosításáért, felfüggesztéséért vagy megszüntetéséért.'
            ]
          }
        ]
      },
      {
        TITLE: 'Megszűnés',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Saját belátásunk szerint, értesítés nélkül megszüntethetjük vagy felfüggeszthetjük az Alkalmazáshoz való hozzáférését olyan magatartás miatt, amely véleményünk szerint sérti ezeket a Feltételeket, vagy káros más felhasználókra vagy az Alkalmazásra.'
            ]
          }
        ]
      },
      {
        TITLE: 'A felelősség korlátozása',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Az alkalmazandó jog által megengedett legteljesebb mértékben a GriffyReads nem vállal felelősséget semmilyen közvetett, véletlen, különleges, következményes vagy büntető jellegű kárért, amely az alkalmazás használatából származik vagy azzal kapcsolatos.'
            ]
          }
        ]
      },
      {
        TITLE: 'Alkalmazandó jog',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'E Feltételekre a belga jog irányadó, és azokat a belga jognak megfelelően kell értelmezni, függetlenül attól, ha annak kollíziós szabályai más jog alkalmazását írják elő.'
            ]
          }
        ]
      },
      {
        TITLE: 'Lépjen kapcsolatba velünk',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Ha bármilyen kérdése vagy aggálya van a jelen Feltételekkel kapcsolatban, kérjük, vegye fel velünk a kapcsolatot a contact@griffyreads.com címen.'
            ]
          }
        ]
      }
    ]
  }

export default HU_TERMS_AND_CONDITIONS_PAGE_CONSTANTS
